module.exports = __webpack_public_path__ + "img/excel-icon.8750911a.png";